import 'swiper/swiper.min.css'
import { Swiper, SwiperSlide } from 'swiper/react'
import SwiperCore, { SwiperOptions, EffectCoverflow } from 'swiper/core'
import { Component } from 'react'
import { IBrandList, IListProps, IListState } from '../types'
import { YBackGroundImage } from '@/utils/style-methods'
import styles from '../index.module.less'
import { withReactTrack } from '@du/analytics-sdk'
import { createTrackConfig } from '../trackConfig'
import classNames from 'classnames'
import { isFullCn } from '@/utils/font'

SwiperCore.use([EffectCoverflow])

export class SwiperBrand extends Component<IListProps, IListState> {
  onSwiperClick(item: IBrandList) {
    this.props.goToDetail(item)
  }

  render() {
    const brandList = this.props.brandList
    // todo: 优化卡顿
    const swiperConfig: SwiperOptions = {
      effect: 'coverflow',
      // className: 'swiper-container-3d',
      grabCursor: true,
      centeredSlides: true,
      // slidesPerView: 2.16,
      // 谨慎修改这个值,
      // 为什么要有这个值呢？preview 他不香么
      slidesPerView: 'auto',
      loop: true,
      // shouldSwiperUpdate: true,
      coverflowEffect: {
        // rotate: 0,
        // stretch: 80,
        // depth: 200,
        // modifier: 1,
        // slideShadows: false,
        rotate: 0, // slide做3d旋转时Y轴的旋转角度。默认50。
        stretch: 0, // 每个slide之间的拉伸值（距离），越大slide靠得越紧。 默认0。
        depth: 130, // 谨慎修改这个值 slide的位置深度。值越大z轴距离越远，看起来越小。 默认100。
        modifier: 1, // depth和rotate和stretch的倍率，相当于depth*modifier、rotate*modifier、stretch*modifier，值越大这三个参数的效果越明显。默认1。
        slideShadows: false, // 开启slide阴影。默认 true。
      },
    }

    return (
      <Swiper {...swiperConfig}>
        {brandList.map((item, index) => {
          const style = YBackGroundImage(item.brandBackImg, 3 * 280)

          return (
            <SwiperSlide
              key={item.brandName + index}
              className={styles['swiper-brand-box']}
              onClick={() => this.onSwiperClick(item)}
            >
              <TrackItem item={item} style={style}></TrackItem>
            </SwiperSlide>
          )
        })}
      </Swiper>
    )
  }
}

// 为了埋点独立出来
@withReactTrack({ createTrackConfig })
class TrackItem extends Component<{ item: IBrandList; style: any }> {
  render() {
    const { item, style } = this.props
    return (
      <div
        data-track-click="poizon_venue_component_content_click"
        data-track-exposure="poizon_venue_component_content_exposure"
        data-blockType="1641"
        data-url={item.redirectValue}
      >
        {/* 图 */}
        <div className={styles['brand-img']} style={style}></div>
        {/* 标记 */}
        <div className={styles['sub-title']}>{item.interestDesc}</div>
        {/* 品牌名称 */}
        <div
          className={classNames({
            [styles['brand-name']]: true,
            [styles['brand-en']]: !isFullCn(item.brandName),
          })}
        >
          {item.brandName}
        </div>
        <div className={styles['brand-desc']}>- {item.brandDesc} -</div>
      </div>
    )
  }
}
